export const isTwoColLayoutType = (type?: string): boolean => type === 'mrc-heading' || type === 'clause-heading';
